import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationBoxComponent } from './notification-box.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [NotificationBoxComponent],
  imports: [
    CommonModule,
    // SharedModule
  ],
  exports: [
    NotificationBoxComponent
  ]
})
export class NotificationBoxModule { }
